import { render, staticRenderFns } from "./PerformanceSolar.vue?vue&type=template&id=482bb43c&"
import script from "./PerformanceSolar.vue?vue&type=script&lang=js&"
export * from "./PerformanceSolar.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports